import React, {useEffect, useRef, useState} from 'react';
import './index.scss';
import HeaderTop, { HeaderTopProps } from '../../molecules/header-top';
import HeaderBottom, { HeaderBottomProps } from '../../molecules/header-bottom';
import ToastContainer from '../../molecules/toast-container';

interface HeaderProps extends HeaderTopProps, HeaderBottomProps {}

const Header = ({
    authenticated, authenticatedAndOnboarded, navigationItems, newDocumentsAction, newMessagesAction, employerUnit,
}: HeaderProps) => {
    const baseClassName = 'o-header';

    const ref = useRef<HTMLDivElement|null>(null);
    const lastY = useRef(0);
    const HIDING_THRESHOLD_PX = 80;
    const JITTER_DELTA = 6;
    const MEDIA_QUERY = '(min-width: 992px)';

    useEffect(() => {
        if (!authenticatedAndOnboarded) {
            return;
        }

        const el = ref.current!;
        // scroll up/down animation is armed once the initial transition is completed
        const onIntroEnd = () => el.classList.add('armed');
        el.addEventListener('animationend', onIntroEnd, {once: true});

        const mql = window.matchMedia(MEDIA_QUERY);

        const onScroll = () => {
            // desktop + post-initial-animation only
            if (!mql.matches || !el.classList.contains('armed')) {
                return;
            }
            const y = Math.max(0, window.scrollY);
            const down = y > lastY.current + JITTER_DELTA;
            const up = y < lastY.current - JITTER_DELTA;

            if (down && y > HIDING_THRESHOLD_PX) {
                el.classList.add('is-hidden');
            } else if (up || y <= HIDING_THRESHOLD_PX) {
                el.classList.remove('is-hidden');
            }

            lastY.current = y;
        };

        window.addEventListener('scroll', onScroll, {passive: true});
        return () => {
            window.removeEventListener('scroll', onScroll);
            el.removeEventListener('animationend', onIntroEnd);
        };
    }, []);

    return (
        <div className={`${baseClassName}`}>
            <div className={`${baseClassName}__borderTop`} />
            <div className={`${baseClassName}__wrapper`} ref={ref}>
                <HeaderTop authenticated={authenticated} authenticatedAndOnboarded={authenticatedAndOnboarded} employerUnit={employerUnit} />
                <HeaderBottom authenticatedAndOnboarded={authenticatedAndOnboarded} navigationItems={navigationItems} newDocumentsAction={newDocumentsAction} newMessagesAction={newMessagesAction} />
                <ToastContainer />
            </div>
        </div>
    );
};

export default Header;
